import React from 'react';

interface IProps {
    options: string[];
    toggleState: string;
    setToggleState: (state: string) => void;
}

const className = 'h-[40px] rounded-[30px] text-[18px] flex items-center justify-center px-3 min-w-[98px]';

const TwoChoiceToggler = ({ options, toggleState, setToggleState }: IProps) => {
  const selectedKeys = [
    { option: options[0], key: 'mainAccount' },
    { option: options[1], key: 'buckets' },
  ];
  return (
    <div className='h-[48px] w-[204px] rounded-[30px] flex items-center justify-center bg-bw02 cursor-pointer px-1 select-none mb-[1.25rem]'>
      {selectedKeys.map((selection, index) => (
        <div id={`chooseOption-${index}`} role='presentation' key={selection.key} onClick={() => setToggleState(selection.key)} className={toggleState === selection.key ? `${className} bg-action01 text-action03 font-metricMedium` : `${className} text-bw08 font-metric`}>{selection.option}</div>
      ))}
    </div>
  );
};

export default TwoChoiceToggler;
